<template>
    <van-grid :column-num="3">
        <van-grid-item :icon="sale" text="仪器销售" to="/intebosale" />
        <van-grid-item :icon="train" text="门店培训" to="/intebotrain" />
        <van-grid-item :icon="storesale" text="店销登记" to="/intebostoresale" />
        <van-grid-item :icon="sncode" text="SN登记" to="/intebosn" />
        <van-grid-item :icon="checkout" text="结账单" to="/intebocheckout" />
        <!--<van-grid-item :icon="notpay" text="未支付金额" to="/notpay" />-->
        <van-grid-item :icon="notdj" text="未退定金" to="/notbackdj" />
        <van-grid-item :icon="notsend" text="未赠送" to="/notsend" />
        <van-grid-item :icon="notintroduce" text="未结算介绍费" to="/notintroduce" />
        <van-grid-item :icon="bonus" text="未退PK金" to="/nobackbonus" />
        <van-grid-item :icon="fine" text="员工罚款" to="/intebostafffine" />
        <!--<van-grid-item :icon="storedaily" text="日报表" to="/dailyreport" />-->
        <van-grid-item :icon="face" text="员工考勤" to="/intebostaffattend" />
        <van-grid-item :icon="wesite" text="客户咨询" to="/seachwebsite" />
    </van-grid>
</template>
<script>
export default {
    data() {
        return {
            sale:require('../../../assets/sale.png'),
            train:require('../../../assets/train.png'),
            storesale:require('../../../assets/storesale.png'),
            notpay:require('../../../assets/notpay.png'),
            notdj:require('../../../assets/notdj.png'),
            notsend:require('../../../assets/intebosend.png'),
            notintroduce:require('../../../assets/introduce.png'),
            fine:require('../../../assets/fine.png'),
            bonus:require('../../../assets/bonus.png'),
            storedaily:require('../../../assets/storedaily.png'),
            face:require('../../../assets/face.png'),
            sncode:require('../../../assets/sncode.png'),
            wesite:require('../../../assets/wesite.png'),
            checkout:require('../../../assets/checkout.png'),
        }
    },
    created() {
        //this.$getInteboQyWechatLogin("/intebotab");
    },
    methods:{

    }
}
</script>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/intebotab.vue